import React from "react";
import "./LoadingScreen.css";

type LoadingScreenProps = {
    message: React.ReactNode;
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({message})=> {
    return (
        <div className="loader">
            <div className="lds-grid">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <header>{message}</header>
        </div>
    );
}

export default LoadingScreen;